import type { ThemeSelectFragment } from '~/api/graphql/fragments/theme.generated';
import type { ShopifyTheme } from '~/modules/shopify/types';

import { create } from 'zustand';

type ThemeStore = {
  theme?: ThemeSelectFragment;
  setTheme: (theme?: ThemeSelectFragment) => void;
  getTheme: () => ThemeSelectFragment | undefined;
  shopifyTheme?: ShopifyTheme;
  setShopifyTheme: (shopifyTheme?: ShopifyTheme) => void;
  getShopifyTheme: () => ShopifyTheme | undefined;
};

export const useThemeStore = create<ThemeStore>()((set, get) => ({
  theme: undefined,
  setTheme: (theme) => set({ theme }),
  getTheme: () => get().theme,
  shopifyTheme: undefined,
  setShopifyTheme: (shopifyTheme) => set({ shopifyTheme }),
  getShopifyTheme: () => get().shopifyTheme,
}));

export default useThemeStore;
